import type { DateValue } from '@internationalized/date'

/**
 * Format a DateValue object to a string in "YYYY-MM-DD" format
 * @param date - DateValue object from @internationalized/date
 * @returns Formatted date string "YYYY-MM-DD"
 */
export function formatDateValueToString(date: DateValue): string {
  return `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`
}

/**
 * Format a day number to a two-digit string
 * @param day - Day number (1-31)
 * @returns Two-digit day string "DD"
 */
export function formatDayToString(day: number): string {
  return day.toString().padStart(2, '0')
}

/**
 * Check if a date string represents a Sunday
 * @param dateStr - Date string in "YYYY-MM-DD" format
 * @returns true if the date is a Sunday
 */
export function isSunday(dateStr: string): boolean {
  const dayNumber = new Date(dateStr).getDay()
  return dayNumber === 0
}

/**
 * Build a reference date string from a base date and day number
 * @param baseDate - Base date in "YYYY-MM-" format
 * @param day - Day number (1-31)
 * @returns Date string in "YYYY-MM-DD" format
 */
export function buildReferenceDateString(baseDate: string, day: number): string {
  return `${baseDate}${formatDayToString(day)}`
}

/**
 * Get the month string from a date string
 * @param dateStr - Date string in "YYYY-MM-DD" format
 * @returns Month string in "YYYY-MM" format
 */
export function getMonthFromDateString(dateStr: string): string {
  return dateStr.slice(0, 7)
}
